module.exports = __webpack_public_path__ + "static/gallagher-logo-2aacc11453c8854f2cb9dec876572ac4.png";